import { TLoginModel } from "../../../../types/Auth/login";


const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'
const getAuth = (): TLoginModel  => {
  let defaultResponse:TLoginModel = {
    status: false,
    message: ""
  };
  if (!localStorage) {
    return defaultResponse
  }

  const lsValue: string  = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY) || ""
  if (!lsValue) {
    return defaultResponse
  }

  try {
    const auth: TLoginModel = JSON.parse(lsValue) as TLoginModel
    if (auth) {
      // You can easily check auth_token expiration also
      return auth
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
  }
  return defaultResponse
}

const setAuth = (auth: TLoginModel) => {
  if (!localStorage) {
    return
  }

  try {
    const lsValue = JSON.stringify(auth)
    localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

const removeAuth = () => {
  if (!localStorage) {
    return
  }

  try {
    localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE REMOVE ERROR', error)
  }
}

export function setupAxios(axios: any) {
  axios.defaults.headers.Accept = 'application/json'
  axios.interceptors.request.use(
    (config: {headers: {Authorization: string}}) => {
      const auth = getAuth()
      if (auth && auth.token) {
    
        config.headers.Authorization = `Bearer ${auth.token}`
    
      }

      return config
    },
    (err: any) => Promise.reject(err)
  )
}

export {getAuth, setAuth, removeAuth, AUTH_LOCAL_STORAGE_KEY}
